var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarSnackbarSuccessIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  y: 0.5,
  width: 24,
  height: 24,
  rx: 6,
  fill: "#1D1B20"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 13L10.5 15L15.5 10",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarSnackbarSuccessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_snackbar_success_icon.be0b74fffe7a004df27c7a05aba7af1f.svg";